import { render, staticRenderFns } from "./GStudentRecordInterviewNavi.vue?vue&type=template&id=208e3966&scoped=true&"
import script from "./GStudentRecordInterviewNavi.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordInterviewNavi.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordInterviewNavi.vue?vue&type=style&index=0&id=208e3966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e3966",
  null
  
)

export default component.exports